import cn from 'classnames';
import dayjs from 'dayjs';
import { FC } from 'react';
import { MdDeleteForever } from 'react-icons/md';
import { IconButton } from '../../../../components/icon-button/icon-button';
import { Label } from '../../../../components/label/label';
import { Rating } from '../../../../components/rating/rating';
import { useLang } from '../../../../hooks/use-lang';
import { decodeHTML, FirebaseNotificationType, notifMap } from '../../notification-helpers';
import s from '../mobile-notifications.module.css';

interface Props {
  notifications: FirebaseNotificationType[];
  handleRemoveNotification: (id: string) => void;
}

export const NotificationsList: FC<Props> = ({ notifications, handleRemoveNotification }) => {
  const { t } = useLang();

  return (
    <ul className={s.list}>
      {notifications.length ? (
        notifications.map(({ rate, body, id, type, read, createdAt }) => (
          <li key={id} className={cn(s.item, read && s.read)}>
            <span className={s.date}>{dayjs(createdAt).format('DD.MM.YYYY')}</span>

            <Label className={s.label}>
              {t(notifMap[type])}

              <IconButton
                size="sm"
                variant="secondary"
                onClick={() => handleRemoveNotification(id)}
              >
                <MdDeleteForever />
              </IconButton>
            </Label>

            {rate && <Rating rate={rate} />}

            {['delay', 'possible_delay', 'serious_delay'].includes(type) && <div>⏱️</div>}

            <p dangerouslySetInnerHTML={{ __html: decodeHTML(body) }} />
          </li>
        ))
      ) : (
        <li className={s.item}>{t('Уведомлений нет')}</li>
      )}
    </ul>
  );
};
